
import { defineComponent, PropType } from 'vue'
import { PackageType, VulnerabilityOccurrence } from '~/types/types'
import VulnerabilityListItem from './VulnerabilityListItem.vue'

import Paginator from './Paginator.vue'

export interface VulnerabilitiesPropT {
  vulnerabilities: VulnerabilityOccurrence[]
  currentPage: number
  hasNextPage: boolean
  totalCount: number
  perPageCount: number
}

const MAX_SKELETON_LOADER_COUNT = 20

export default defineComponent({
  name: 'VulnerabilityList',
  components: {
    VulnerabilityListItem,
    Paginator
  },
  data() {
    return {
      PackageType
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    item: {
      type: Object as PropType<VulnerabilitiesPropT>,
      required: true
    },
    subcategory: {
      type: String as PropType<PackageType>,
      required: true
    },
    itemsToShow: {
      type: Number,
      default: 10
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    allRoute() {
      const { provider, owner, repo, target } = this.$route.params
      return {
        name: 'provider-owner-repo-dependencies-target-vulnerabilities',
        params: { provider, owner, repo, target },
        query: { pkgType: this.subcategory }
      }
    },
    vulnerabilitiesN() {
      return this.item.vulnerabilities.slice(0, this.itemsToShow)
    },
    startItemNumber(): number {
      if (this.item.totalCount === 0) return 0
      const n = this.item.currentPage * this.item.perPageCount - (this.item.perPageCount - 1)
      return n > 0 ? n : 0
    },
    endItemNumber() {
      const n = this.item.currentPage * this.item.perPageCount
      return n > this.item.totalCount ? this.item.totalCount : n
    },
    loaderCount() {
      return Math.min(this.itemsToShow, MAX_SKELETON_LOADER_COUNT)
    }
  }
})
